module.exports = __webpack_public_path__ + "static/media/heroin.c7ebf54c.svg";